import { axios } from '@/utils/request'

const api = {
  Pre: '/merchant.php/repair/pre',
  List: '/merchant.php/repair/getList',
  Save: '/merchant.php/repair/saveSetting',
  SendCode: '/merchant.php/Base/sendSmsCode',
  phoneSetting: '/merchant.php/repair/editPhone',
  getPhone: '/merchant.php/repair/getPhone'
}

// 预加载
export function getPre () {
  return axios({
    url: api.Pre,
    method: 'get'
  })
}

export function getList (parameter) {
  return axios({
    url: api.List,
    method: 'get',
    params: parameter
  })
}

export function saveSetting(data) {
  return axios({
    url: api.Save,
    method: 'post',
    data: data
  })
}

export function remark(data) {
  return axios({
    url: '/merchant.php/repair/remark',
    method: 'post',
    data: data
  })
}

export function sendCode(data) {
  return axios({
    url: api.SendCode,
    method: 'post',
    data: data
  })
}

export function phoneSetting(data) {
  return axios({
    url: api.phoneSetting,
    method: 'post',
    data: data
  })
}

export function getPhone() {
  return axios({
    url: api.getPhone,
    method: 'get'
  })
}
